export enum JournalTitleEntry {
  diary = "Diary Entry",
  gratitude = "Gratitude Journal Entry",
  iAmGreat = "I am great Journal Entry",
  fiveMinute = "5 Minute Journal Entry",
}
